export default "__VITE_ASSET__5024bab2__"